import React from 'react';
import PropTypes from 'prop-types';
import { newAccountToBasic, prettyOldPlanName } from '../../../utils/planStringConversion';
import InlineMessage from '../../Global/Messages/InlineMessage';

const LegacyPlanMessage = ({ signup }) => {
  let legacyPlanMessage = null;
  if ('user_details' in signup) {
    const planName = newAccountToBasic(signup.user_details.plan);

    switch (planName) {
      case 'basic':
      case 'standard':
      case 'premium':
      case 'enterprise':
        // Do nothing
        break;

      default:
        legacyPlanMessage = (
          <InlineMessage classes="m-b-5">
            <p className="m-b-0 like-h5">You are currently on the discontinued <span className="fw-bold text-capitalize">{prettyOldPlanName(planName)}</span> plan, but you are able to enjoy the same benefits as the <span className="fw-bold text-capitalize">{signup.user_details.computed_access}</span> plan in the table below.</p>
          </InlineMessage>
        );
    }
  }

  return legacyPlanMessage;
};

LegacyPlanMessage.propTypes = {
  signup: PropTypes.object.isRequired,
};

export default LegacyPlanMessage;



// WEBPACK FOOTER //
// ./library/app/components/Account/YourPlan/LegacyPlanMessage.js